import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, spacing } from 'ui/theme';
import { smallShadow } from 'ui/theme/shadows';
import { subtitle2 } from 'ui/theme/typography';

// This is slightly more than zeroheight to make room for the scrollbar
export const PANEL_WIDTH = 225;
export const REVIEW_PANEL_WIDTH = 400;

/* POSITIONING CONTAINERS */
export const StyledSidebar = styled.div`
  background-color: ${colors.backgroundSecondary};
  box-shadow: ${smallShadow.boxShadow};
  display: flex;
  max-height: calc(100vh - 121px);
  overflow-y: auto;
`;

export const StyledTilePanel = styled(StyledSidebar)`
  width: ${pxToRem(PANEL_WIDTH)};
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: ${spacing.base};
  max-height: 100%;
  height: 100%;
  user-select: none;
  overflow-x: hidden;

  /** calculated to make room for support icon */
  ${({ $supportChatTest }) => $supportChatTest === false && 'padding-bottom: 67px;'}
`;

/* TILES */
export const TileSections = styled.div`
  padding: ${spacing.threeQuarter};
`;

export const StyledNodeTileSection = styled.div`
  margin-bottom: ${spacing.plusHalf};
`;

export const NodeTypeLabel = styled.div`
  ${subtitle2};
  color: ${colors.textPrimary};
  padding-bottom: ${spacing.half};
`;

export const NodeTiles = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.half};

  > * {
    width: calc(50% - ${spacing.quarter});
  }
`;
